import React from 'react';
import BlogMain from './BlogMain';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import Breadcrumb from '../../components/Breadcrumb';
import ScrollToTop from '../../components/ScrollTop';

import Logo from '../../assets/images/logos/logo2.png';
import FooterTwo from '../../components/Footer/FooterTwo';

const Blog = () => {
    return (
        <body className="blog-post-page">
            <Header
                parentMenu='blog'
                menuCategoryEnable='enable'
                headerNormalLogo={Logo}
                headerStickyLogo={Logo}
            />

            <div class="react-wrapper">
                <div class="react-wrapper-inner">
                    <Breadcrumb
                        pageTitle="Blog"
                    />

                    <BlogMain />

                    {/* scrolltop-start */}
                    <ScrollToTop />
                    {/* scrolltop-end */}
                </div>
            </div>

            {/* <Footer /> */}
            <FooterTwo/>
            
        </body>
    );
}


export default Blog;

